import { render } from "./messagTemplate.vue?vue&type=template&id=6227d778"
import script from "./messagTemplate.vue?vue&type=script&lang=js"
export * from "./messagTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__